import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { FeaturePage } from "@/components/site/FeaturePage";
import { DemoForm } from "@/components/site/DemoForm";
import { FEATURE_PAGES } from "@/featureData";

export default function FeatureDetail() {
  const { slug } = useParams();
  const [demoOpen, setDemoOpen] = useState(false);
  const data = FEATURE_PAGES[slug];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!data) return <Navigate to="/" replace />;

  return (
    <div data-testid={`feature-page-${slug}`}>
      <Navbar onBookDemo={() => setDemoOpen(true)} />
      <FeaturePage data={data} onBookDemo={() => setDemoOpen(true)} />
      <Footer />
      <DemoForm open={demoOpen} onClose={() => setDemoOpen(false)} />
    </div>
  );
}
